import { pleaseConfirm } from "../utils/common";
var prefixMessage = "if you currently have";
var VARIANTS = {
  ARHI: "".concat(prefixMessage, " health insurance"),
  IMAN: "".concat(prefixMessage, " Australian health insurance"),
  IWHI: "".concat(prefixMessage, " Australian health insurance"),
  ISHI: "".concat(prefixMessage, " OSHC health insurance"),
  IAP: "whether the student is transferring from another Australian OSHC provider"
};
var validTransferringFundsRadio = function validTransferringFundsRadio(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  var message = funnel === "IAP" && fieldName || VARIANTS[funnel] || VARIANTS.ARHI; // IAP can be both workers or students, so IAP workers we'll pass in a fieldname value but not for students
  if (fieldName && funnel !== "IAP") {
    message = "".concat(prefixMessage, " ").concat(fieldName);
  }
  if (!value) {
    error = pleaseConfirm(message);
  }
  return error;
};
export default validTransferringFundsRadio;